import request from '../request'
// import { USER_INFO } from '@/store/mutation-types'
// import storage from 'store'

// const userInfo = storage.get(USER_INFO)

export default {
  login(parameter) {
    return request({
      // url: 'user/login',
      // baseURL: process.env.VUE_APP_BK_API_BASE_URL,
      url: 'api/login',
      baseURL: process.env.VUE_APP_NAPI_BASE_URL,
      method: 'post',
      data: parameter,
    })
  },
 getInfo () {
  return request({
    url: 'user/info',
    method: 'get',
    baseURL: process.env.VUE_APP_BK_API_BASE_URL,
  })
}
}
